import {useQuery} from 'react-query';
import {getInstallmentPrice} from './getInstallmentPrice';

const useGetInstallmentPrice = (loanRequestGuid?: string) => {
  const {data, isLoading, isSuccess} = useQuery({
    queryKey: ['get-installment-price', loanRequestGuid],
    queryFn: () => getInstallmentPrice(loanRequestGuid),
    enabled: !!loanRequestGuid,
  });

  return {data, isLoading, isSuccess};
};
export default useGetInstallmentPrice;
